import "../../css/ProfileBadge.css";
import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import ProfileBadgeImg from "../../assets/images/badge/VandeMataram.png";
import { Link } from "react-router-dom";
import { getCurrentUserId } from "../../utils/auth";
import { useProfile } from "../../hook/useProfile";

export default function ProfileBadge({ profilePic, isBatch, ProfileLink, imgClassName="", badgeClassName="" }) {
  const currentUserId = getCurrentUserId();
  const [isCheckBadge, setCheckBadge] = useState();
  //   const profileLink = `/my/${currentUserId}/profile`;
  const { isProfileInfo } = useProfile();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [isUserProfileBadge, setIsUserProfileBadge] = useState();

  // useEffect(() => {
  //   const fetchMyProfile = async () => {
  //     try {
  //       const res = await api.get("/user/me");
  //       setCheckBadge(res?.data);
  //     } catch (err) {
  //       console.error("Profile fetch error", err);
  //     }
  //   };
  //   fetchMyProfile();
  // }, []);

  // const isBadgeActive = isCheckBadge?.user?.isBatch;

  return (
    <>
      <div className={`profile_badge_container ${imgClassName}`}>
        <Link to={ProfileLink}>
          <img
            src={`${profilePic}`}
            alt="user"
            className="myProfile_img_section"
            onError={(e) => {
              e.target.src =
                "https://cdn-icons-png.flaticon.com/512/149/149071.png";
            }}
          />
          {isBatch && (
            <div className={`profile_badge_img_section ${badgeClassName}`}>
              <img src={ProfileBadgeImg} alt="" />
            </div>
          )}
        </Link>
      </div>
    </>
  );
}
